/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const PayLater: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.5 7.5C3.5 5.29086 5.29086 3.5 7.5 3.5H16.5C18.7091 3.5 20.5 5.29086 20.5 7.5V11.6949V16.5C20.5 18.7091 18.7091 20.5 16.5 20.5H11.6949H7.5C5.29086 20.5 3.5 18.7091 3.5 16.5V7.5ZM7.5 18.5C6.39543 18.5 5.5 17.6046 5.5 16.5V9L18.5 9V11.6949C18.5 12.2253 18.2893 12.734 17.9142 13.1091L13.1091 17.9142C12.734 18.2893 12.2253 18.5 11.6949 18.5H7.5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
